/**
 * Size recommendations cache.
 */
export class SizeRecommendationCache {
  private readonly _recommendationsMap: Map<string, string> = new Map();

  /**
   * Returns the recommendation associated with the specified params. If no element is associated with the specified, undefined is returned.
   * @param avatarId the avatar ID.
   * @param garmentId the garment ID.
   * @param variant the variant name.
   */
  getRecommendation(avatarId: string, garmentId: string, variant: string): string | undefined {
    const uniqueId = `${avatarId}-${garmentId}-${variant}`;
    const value = this._recommendationsMap.get(uniqueId);
    return value;
  }

  /**
   * Adds a new recommendation with the specified params to the Map. If an element with the same key already exists, the element will be updated.
   * @param avatarId the avatar ID.
   * @param garmentId the garment ID.
   * @param variant the variant name.
   * @param value the recommendation value.
   */
  setRecommendation(avatarId: string, garmentId: string, variant: string, value: string) {
    const uniqueId = `${avatarId}-${garmentId}-${variant}`;
    this._recommendationsMap.set(uniqueId, value);
  }
}
